import React from 'react';

const Container = ({children}) => {
    return (
        <div className=''>
            {children}
        </div>
    );
};

export default Container;